import {Suspense, useRef} from 'react';
import {Button, ProductCard} from '~/components';
import {useBestSellers} from '~/hooks/index';

export function CartEmpty({onClose}: {onClose?: () => void}) {
  const scrollRef = useRef(null);

  return (
    <div
      ref={scrollRef}
      className="h-screen-no-nav grid max-w-xl content-start gap-y-4 overflow-y-auto bg-white px-6 py-8 transition md:gap-y-12 md:px-12 md:pb-12"
    >
      <section className="grid gap-6">
        <span>Seamless self-care is just a few clicks away</span>
        <div>
          <Button handleClick={onClose}>Continue Browsing</Button>
        </div>
      </section>
      <section className="grid gap-8 pt-4">
        <span>Discover Refresh Favorites</span>
        <div className="grid grid-cols-2 gap-x-6 gap-y-8">
          <Suspense fallback={<Loading />}>
            <TopProducts onClose={onClose} />
          </Suspense>
        </div>
      </section>
    </div>
  );
}

function TopProducts({onClose}: {onClose?: () => void}) {
  const {data: products = []} = useBestSellers();

  if (products.length === 0) {
    return <span>No products found.</span>;
  }

  return (
    <>
      {products
        .filter((product) => product.handle != 'surge-fee')
        .slice(0, 4)
        .map((product) => (
          <ProductCard product={product} key={product.id} onClick={onClose} />
        ))}
    </>
  );
}

function Loading() {
  return (
    <>
      {[...new Array(4)].map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={i} className="grid gap-2"></div>
      ))}
    </>
  );
}
